import { render } from "./ProductsHome.vue?vue&type=template&id=4caa90e6&scoped=true"
import script from "./ProductsHome.vue?vue&type=script&lang=js"
export * from "./ProductsHome.vue?vue&type=script&lang=js"

import "./ProductsHome.vue?vue&type=style&index=0&id=4caa90e6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2009374271/src/sayuri/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4caa90e6"]])

export default __exports__